import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { environment } from "../environments/environment";
import { RootState } from './store';

export interface Notification {
    id: number;
    message: string;
    createTime: string;
    acknowledged: boolean;
}

interface NotificationState {
    notifications: Notification[];
    isLoading: boolean;
    error: string | null;
}

const initialState: NotificationState = {
    notifications: [],
    isLoading: false,
    error: null
};

export const getNotificationData = createAsyncThunk(
    'notification/getNotificationData',
    async () => {
        const baseURL = environment.apiURL;
        const response = await axios.get(`${baseURL}/notifications`);
        return response.data;
    }
);

const notificationSlice = createSlice({
    name: 'notification',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getNotificationData.pending, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(getNotificationData.fulfilled, (state, action) => {
                state.notifications = action.payload;
                state.isLoading = false;
            })
            .addCase(getNotificationData.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.error.message || 'Failed to fetch notifications';
            });
    }
});

// Selectors
export const selectNotifications = (state: RootState) => state.notification.notifications;
export const selectIsLoading = (state: RootState) => state.notification.isLoading;
export const selectError = (state: RootState) => state.notification.error;

export default notificationSlice.reducer;